export default "__VITE_PUBLIC_ASSET__05300879__"